module.exports = __webpack_public_path__ + "static/media/clean1.bb93796e.jpg";